// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getScheduledLinesApi, SchedulesLinesApiResult } from "@eisinc/App/Services/ScheduleOrderService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";

interface TimeStampedApiParamter extends ApiParameter {
    timestamp?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    TimeStampedApiParamter & HasOnSuccess & { onError?: (error: string) => void },
    TimeStampedApiParamter,
    ServiceResult<SchedulesLinesApiResult>
>;

export const SendDataToApi: HandlerType = async props => {
    props.dispatch({ type: "xCommon/update", data: { key: "isLoadingScheduledLines", value: true } } as any);
    const timestamp = `time${new Date().getTime()}`;
    props.apiResult = await getScheduledLinesApi({ timestamp });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({ type: "xCommon/update", data: { key: "isLoadingScheduledLines", value: false } } as any);

        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({ type: "xCommon/update", data: { key: "isLoadingScheduledLines", value: false } } as any);

        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getScheduledLines = createHandlerChainRunner(chain, "GetScheduledLines");
export default getScheduledLines;
